// extracted by mini-css-extract-plugin
module.exports = {"bundlesBg":"watchlistWrappedContainer_bundlesBg__ZgQXQ"};